<template>
  <div class="flex items-center justify-center w-full h-full p-1" :title="tooltip">
    <font-awesome-icon
      v-if="hasAttachments"
      :icon="['fal', 'paperclip']"
      class="text-base text-accent"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAttachmentStore } from '@/store/attachmentStore'

const props = defineProps<{
  modelValue?: any
  rowId?: number | string
  header?: any
  readOnly?: boolean
  singleLine?: boolean
}>()

const attachmentStore = useAttachmentStore()

const hasAttachments = computed(() => {
  if (!props.rowId) return false
  const rowId = Number(props.rowId)
  const count = attachmentStore.getAttachmentCount(rowId)
  return count > 0
})

const tooltip = computed(() => {
  if (!props.rowId) return ''
  const rowId = Number(props.rowId)
  const count = attachmentStore.getAttachmentCount(rowId)
  if (count === 0) return ''
  return count === 1 ? '1 vedlegg' : `${count} vedlegg`
})
</script>

